import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class ConfirmForm extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    confirmString: PropTypes.string.isRequired,
    cancelString: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    // extraAction is close modal action, used in no-react environment
    extraAction: PropTypes.func,
  };

  static defaultProps = {
    extraAction: () => {},
  };

  onConfirm = () => {
    this.props.onConfirm();
    this.props.extraAction();
  };

  onCancel = () => {
    this.props.onCancel();
    this.props.extraAction();
  };

  render() {
    const {
      title,
      content,
      confirmString,
      cancelString,
      i18n,
    } = this.props;

    return (
      <div
        className="recommendation-confirm-form"
      >
        <button
          className={classNames('close', 'closeimage')}
          onClick={this.onCancel}
          aria-label={i18n.getString('Button_Close')}
        />
        <h3 className="recommendation-confirm-title">{title}</h3>
        <div className="recommendation-confirm-content">{content}</div>
        <button
          className={classNames('btn', 'btn-hero', 'btn-confirm')}
          onClick={this.onConfirm}
        >
          {confirmString}
        </button>
        <button
          className={classNames('btn', 'btn-default', 'btn-cancel')}
          onClick={this.onCancel}
        >
          {cancelString}
        </button>
      </div>
    );
  }
}
